export default {
  session: {
    fluxId: undefined,
    externalLogin: false,
    channel: 'web',
    page: {
      url: undefined,
      enterDate: new Date(),
      leaveDate: undefined,
      scrollPercent: 0
    },
    pages: [],
    existentContact: false
  },
  restoringSession: true,
  flux: undefined,
  surveyFinished: false
}
